import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Checkbox, Form, Input, Textarea } from "react-daisyui";
import { mutations, wrapMutation } from "../graphql";
import { CreateZoneMutationVariables } from "../API";
import useZoneId from "../hooks/useZoneId";
import { useEffect, useState } from "react";
import useCurrentUser from "../hooks/useCurrentUser";
import { Link } from "react-router-dom";

function CreateZone() {
  const currentUser = useCurrentUser();
  console.log("currentUser", currentUser);
  const queryClient = useQueryClient();
  const zoneId = useZoneId();
  useEffect(() => {
    setUsername(currentUser?.username || "");
  }, [currentUser]);
  const [username, setUsername] = useState("");
  const createZoneMutation = useMutation(wrapMutation(mutations.createZone), {
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries(["zone", data?.createZone?.zoneId]);
    },
  });
  return (
    <>
      <div>This zone does not exist yet (...but you can create one!)</div>
      {currentUser == null ? (
        <div>
          To get started, <Link to="/login">login</Link> or{" "}
          <Link to="/register">create a Bandwagon account</Link>.
        </div>
      ) : (
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            const data = new FormData(e.target as HTMLFormElement);
            const payload = Object.fromEntries(data.entries());
            const createZoneParameters =
              payload as unknown as CreateZoneMutationVariables;
            console.log(JSON.stringify(payload));
            createZoneMutation.mutate(createZoneParameters);
          }}
        >
          <div className="form-control">
            <label className="label">
              <span className="label-text">Zone Id</span>
            </label>
            <span className="text-sm text-gray-500">{zoneId}</span>
            <Input
              type="hidden"
              name="zoneId"
              className="input input-bordered"
              value={zoneId}
            />
          </div>
          <div className="form-control">
            <label className="label">
              <span className="label-text">Zone Title</span>
            </label>
            <Input
              type="text"
              name="title"
              required={true}
              placeholder="Zone Title"
              className="input input-bordered"
            />
          </div>
          <div className="form-control">
            <label className="label">
              <span className="label-text">Zone Description</span>
            </label>
            <Textarea
              placeholder="Zone Description"
              name="description"
              required={true}
              className="textarea textarea-bordered h-24"
            ></Textarea>
          </div>
          <div className="form-control">
            <label className="label">
              <span className="label-text">Your username</span>
            </label>
            <Input
              type="text"
              name="username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
              required={true}
              placeholder=""
              className="input input-bordered"
            />
          </div>
          <div className="form-control">
            <Input
              type="submit"
              className="btn btn-primary"
              value="Create Zone"
            />
          </div>
        </Form>
      )}
    </>
  );
}

export default CreateZone;
